<template>
  <div class="FormInscripcion">
    <div v-if="FormInscripcion">
      <b-modal size="lg" id="bv-modal-address" hide-footer>
          <template v-slot:modal-title>Dirección de Residencia</template>
          <div class="detalleAddress">  
            <ValidationObserver ref="obsFieldsAddress">
              <FormAddress :FieldsForm="formAddress" :ModelForm="this.formAddModel" :method="executeProcess" />
            </ValidationObserver>
            <div class="row botonData">
              <div class="text-left  col-md-10">            
              </div>
              <div class="text-right  col-md-2">
                <button type="submit" v-on:click="executeAddress" class="botonRef">Aplicar</button>
              </div>
            </div>
          </div>
      </b-modal> 
      <form-wizard @on-complete="onComplete" next-button-text="Siguiente" back-button-text="Regresar" finish-button-text="Finalizar" title subtitle color="#222">
        <tab-content :title="this.labelFields.fields1" icon="ti-target" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row d-flex flex-column">
              <div class="col infoForm">
                <FormDataInscription /> 
              </div> 
              <div class="col totalform">  
                <ValidationObserver ref="obsFields1">
                  <FormInscription :FieldsForm="formInscription.fields1" :ModelForm="formInsModel" :method="executeProcess" />                                     
                </ValidationObserver>
              </div>       
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields2" icon="ti-user" :before-change="beforeTabSwitch2">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <div v-if="infoValidacion" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Es importante que la información diligenciada en los campos de Fecha de Nacimiento y Confirmación Fecha de Nacimiento esté acorde con el documento de identidad.
                  </p>
                </div>
                <div v-if="alertBirth" class="alert alert-danger" role="alert">
                  Las fechas ingresadas no coinciden, por favor valídalas para continuar con el proceso.
                </div>
                <ValidationObserver ref="obsFields2">
                  <FormInscription :FieldsForm="formInscription.fields2" :ModelForm="this.formInsModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields3" icon="ti-medall-alt" :before-change="beforeTabSwitch3">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <ValidationObserver ref="obsFields3">
                  <FormInscription :FieldsForm="formInscription.fields3" :ModelForm="this.formInsModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields4" icon="ti-ruler-pencil">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">
                <div v-if="alertdanger" class="alert alert-danger" role="alert">
                  Se ha generado un problema con la información ingresada, por favor intente nuevamente el registro.
                </div> 
                <ValidationObserver ref="obsFields4">
                  <FormInscription :FieldsForm="formInscription.fields4" :ModelForm="this.formInsModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>        
      </form-wizard>  
    </div>        
    <div v-if="!FormInscripcion" class="FormInscripcionOK">
      <form-wizard next-button-text="" back-button-text="" finish-button-text="" title subtitle color="#222">
        <tab-content title="Registro Exitoso" icon="ti-thumb-up" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row totalform">              
              <div class="col-md-12">  
                <div class="alert alert-success" role="alert">
                  Gracias, tu información ha sido enviada con éxito.
                  <div class="">
                    <div>
                      <p></p>
                      <p>Descargue el formato de autorización de verificación de información académica, diligenciar y adjuntar documento. Es obligatorio para el proceso de Admisión.</p>
                      <a href="https://services.ibero.edu.co/Files/General/AutorizacionVerificacionAcademica.pdf" target="_blank">                        
                          <img width="30" height="30" src="data:image/png;base64,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" 
                        title="Acta de Compromiso Pregrado" alt="Autorización Verificación Académica" class="img-fluid"> 
                        Autorización Verificación Académica 
                      </a>
                    </div>
                  </div>
                </div>
                <!--<div v-if="alertdangerOrden == true" class="alert alert-danger" role="alert">
                  Se ha generado un problema con la generacion de la orden, valida con un asesor
                </div>-->   
              </div>
              <div id="btn_PayOrder" class="col-md-6 text-left">
                  <button type="submit" class="btn btn-lg botonPay" v-on:click="payOrder" v-if="this.formInsModel.IdInteProgram == '2'">Recibo de Inscripción y Pago en Línea</button>
              </div>
              <div class="col-md-6 text-right" v-if="this.dataObjAllFind(this.$store.state.DegreeList,formInsModel.IdLevelForm).codVal != 'OPG'">                
                <router-link :to="{ name: 'InscripcionFiles', params: { docType: formInsModel.IdDocType, docNum: formInsModel.IdDocument, celNum: formInsModel.IdCelPhone, mailRef: formInsModel.IdMail}}" target="_blank">
                  <button type="submit" class="btn btn-lg botonRef">Cargar Documentos</button>
                </router-link>
              </div>               
              <div class="col-md-12 ">                  
                <div class="container">
                  <div class="row" v-for="(item, index) in this.sumaryData" :key="index">               
                    <div class="col-md-12 ">                  
                      <div class="titleRefSumary">{{index}}</div>                
                    </div>                                 
                    <template v-for="(item1, index1) in item[0]" >
                      <div class="col-md-6 listSumary" :key="index1" v-if="item1 != ''">
                        <div class="col-md-12 titleSumary">{{index1}}</div>                      
                        <div class="col-md-12">{{item1}}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>             
              <div id="btn_PayOrder" class="col-md-6 text-left">
                  <button type="submit" class="btn btn-lg botonPay" v-on:click="payOrder" v-if="this.formInsModel.IdInteProgram == '2'">Recibo de Inscripción y Pago en Línea</button>
              </div>
              <div class="col-md-6 text-right" v-if="this.dataObjAllFind(this.$store.state.DegreeList,formInsModel.IdLevelForm).codVal != 'OPG'">                
                <router-link :to="{ name: 'InscripcionFiles', params: { docType: formInsModel.IdDocType, docNum: formInsModel.IdDocument, celNum: formInsModel.IdCelPhone, mailRef: formInsModel.IdMail}  }" target="_blank">
                  <button type="submit" class="btn btn-lg botonRef">Cargar Documentos</button>
                </router-link>
              </div>               
            </div>
          </div>
        </tab-content>             
      </form-wizard>        
    </div>
  </div>
</template>

<script>
import FormDataInscription from '@/views/InfoZone/FormInscription.vue'
import FormInscription from '@/components/Forms.vue'
import FormAddress from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {  
  name: "FormInscripcion",
  components: {
    FormDataInscription,
    FormInscription,
    FormAddress,
  },
  methods: {
    validationAlfanumeric: function(data)
    {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      if (!regex.test(data)) {
        alert("Estimado(a) estudiante: Es importante que la información diligenciada en el campo de Documento de Identidad no contenga puntos, comas, espacios o caracteres especiales")  
        return false;
      } else return true;
    },
    payOrder: function(){
      let loader = this.$loading.show();
      var NamePeriod = IberoHelpers.dataObjFind(this.$store.state.PeriodoList,this.formInsModel.IdConvoca).split(' ')[0];
      var res = IberoHelpers.getRegistrationPayOrder(this.$store.state.ApiIbero.WSUtilitary,this.formInsModel.IdDocument,NamePeriod);
      var dataLink = this.$store.state.ApiIbero.WSIceBerg;
      res.then(Response => {
                if (Response.data[0].numPayOrder != null && Response.data[0].numPayOrder != "") {
                  window.open(dataLink+"/recibo_pago.zul?numero=" + Response.data[0].numPayOrder + "&tipo=I", "_blank");
                  }
              })
      loader.hide();
    },
    executeAddress: function (){
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsAddress.validate().then(results => {         
          if (!results) {
            IberoHelpers.scrollToTop(0,500);
            resolve(false)
          }else{
            this.formInsModel.IdAddress = this.dataObjFindJs(this.$store.state.listAddress,this.formAddModel.IdAddressList) + ' ' + this.formAddModel.IdAddressStreet + ' # ' + this.formAddModel.IdAddressNum + ' - ' + this.formAddModel.IdAddressRef;
            if(this.formAddModel.IdAddressExtra != ''){
              this.formInsModel.IdAddress += ' | ' + this.formAddModel.IdAddressExtra;
            }
            this.$root.$emit('bv::hide::modal', 'bv-modal-address', '#btnHide')  
            resolve(true)
          }
        });  
      });              
    },
    dataObjCheck: function(InfDaT){
      if(InfDaT === true){
        return this.$ml.get('Accepted');   
      }
      return this.$ml.get('NotAccepted');    
    },
    valNacionality: function(InfDat){
      if(document.getElementById("sum_IdStateBirth") != null){
        if (InfDat.IdNacionality != 169) {
          document.getElementById("sum_IdStateBirth").classList.add('noShow');
          document.getElementById("sum_IdCityBirth").classList.add('noShow');
        } else {
          document.getElementById("sum_IdStateBirth").classList.remove('noShow');
          document.getElementById("sum_IdCityBirth").classList.remove('noShow');
        }
      }
    },
    loadFindData: function(restJson){  
      var datFind = JSON.parse(restJson.Detail)
      var expeditionDate = restJson.Doc_ExpeditionDate;
      var dateRes = expeditionDate.replace('T00:00:00', '')
      var trueRes = dateRes.split("-");
      if (trueRes.length === 3)
      {
        var vDayExp = trueRes[2];
        var vMonthExp = trueRes[1];
        var vYearExp = trueRes[0];
        this.formInsModel.IdDaySelect = vDayExp;
        this.formInsModel.IdMonthSelect = vMonthExp;
        this.formInsModel.IdYearSelect = vYearExp;
      }

      this.formInsModel.IdDateExpDoc = restJson.Doc_ExpeditionDate
      this.formInsModel.IdState = datFind.CodExpeditionDepartment
      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,datFind.CodExpeditionDepartment);
      this.formInscription.fields1[8].values = this.$store.state.CityList;

      this.formInsModel.IdCity = datFind.CodExpeditionCity
      this.formInsModel.IdNombreP = datFind.FamName 
      var namePerson = restJson.NamPerson.replace(datFind.FamName, '')
      this.formInsModel.IdNombreS = namePerson.trim()
      this.formInsModel.IdApellidosP = datFind.FamLastName
      var apePerson = restJson.LastNamePerson.replace(datFind.FamLastName, '')
      this.formInsModel.IdApellidosS = apePerson.trim()
      this.formInsModel.IdAddress = datFind.ResAddress
      
      this.formAddModel.IdAddressList = datFind.ResAddressZone
      this.formAddModel.IdAddressStreet = datFind.ResAddressStreet
      this.formAddModel.IdAddressNum = datFind.ResAddressNumber
      this.formAddModel.IdAddressRef = datFind.ResAddressReference
      this.formAddModel.IdAddressExtra = datFind.ResAddressAditional

      this.formInsModel.IdNeighbor = datFind.ResNeighborhood
      this.formInsModel.IdStateRes = datFind.CodResidenceDepartment
      
      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListRes,datFind.CodResidenceDepartment);
      this.formInscription.fields2[3].values = this.$store.state.CityListRes;

      this.formInsModel.IdCityRes = datFind.CodResidenceCity
      this.formInsModel.IdNacionality = datFind.CodNationality
      this.formInsModel.IdStateBirth = datFind.CodBirthDepartment

      if (this.formInsModel.IdNacionality != 169) {
        document.getElementById("div_IdStateBirth").classList.add('noShow');
        document.getElementById("div_IdCityBirth").classList.add('noShow');
        this.formInsModel.IdStateBirth = '11'
        this.formInsModel.IdCityBirth = '11001'
      } else {
        document.getElementById("div_IdStateBirth").classList.remove('noShow');
        document.getElementById("div_IdCityBirth").classList.remove('noShow');
        this.formInsModel.IdStateBirth = ''
        this.formInsModel.IdCityBirth = ''            
      }

      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListBirth,datFind.CodBirthDepartment);
      this.formInscription.fields2[6].values = this.$store.state.CityListBirth;
      this.formInsModel.IdStateBirth = datFind.CodBirthDepartment
      this.formInsModel.IdCityBirth = datFind.CodBirthCity
      var res = datFind.BirthDate.split("/");
      if (res.length === 3)
      {
      var vDay = res[0];
      var vMonth = res[1];
      var vYear = res[2];
      this.formInsModel.IdDaySelectBirth = vDay;
      this.formInsModel.IdMonthSelectBirth = vMonth;
      this.formInsModel.IdYearSelectBirth = vYear;
      this.formInsModel.IdDateBirth = new Date(vYear + "/" + vMonth + "/" + vDay).toISOString()
      } else{
        this.formInsModel.IdDateBirth = datFind.BirthDate.toISOString()
      }

      this.formInsModel.IdGender = datFind.IdGender

      this.formInsModel.IdEPS = datFind.IdEPS
      this.formInsModel.IdEPSQA = datFind.IdEPSQA

      this.formInsModel.IdEstrato = datFind.IdEstrato
      if (datFind.IdEthnicity === 0)
      {
        this.formInsModel.IdEtnia = 1
      }else
      {
        this.formInsModel.IdEtnia = datFind.IdEthnicity
      }

      this.formInsModel.IdEtnia = datFind.IdEthnicity
      this.formInsModel.IdLeyVete = datFind.IdLeyveteranos
      this.formInsModel.IdDiscapa = datFind.IdDesability
      this.formInsModel.IdCivilState = datFind.IdMaritalStatus
      this.formInsModel.IdHomePhone = restJson.DesContactInformationPhone
      this.formInsModel.IdCelPhone = restJson.DesContactInformationMobile
      this.formInsModel.IdMail = restJson.DesContactInformationEmail
      this.formInsModel.IdContactName = datFind.DesContactInformationNameEmergency
      this.formInsModel.IdContactPhone = datFind.DesContactInformationPhoneEmergency
      this.formInsModel.IdContactCity = datFind.DesContactInformationContactCity
      this.formInsModel.IdContactAdres = datFind.DesContactInformationContactAdres
      this.formInsModel.IdWork = datFind.DesContactInformationWork
      this.formInsModel.IdPersons = datFind.DesContactInformationPersons
      this.formInsModel.IdMaterial = datFind.DesContactInformationMaterial
      
      this.formInsModel.IdTypeColegio = (datFind.IdSchoolType === 0)?'':datFind.IdSchoolType
      this.formInsModel.IdColegio = datFind.NamSchool
      this.formInsModel.IdStateCol = datFind.CodDepartmentSchool

      if (datFind.CodDepartmentSchool != ''){
        IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListCol,datFind.CodDepartmentSchool);
      }
      this.formInscription.fields4[4].values = this.$store.state.CityListCol;      

      this.formInsModel.IdCityCol = datFind.CodCitySchool
      this.formInsModel.IdJornadaEsc = (datFind.IdWorkdaySchool === 0)?'':datFind.IdWorkdaySchool
      this.formInsModel.IdNumRegICFES = datFind.ICFESRegistrationNumber
      this.formInsModel.IdNumRegYearICFES = datFind.ICFESYear
      this.formInsModel.IdDocTypeICFES = datFind.ICFESIdentificationType
      this.formInsModel.IdNumICFES = datFind.ICFESIdentificationNumber
      this.formInsModel.IdInteProgram = datFind.IdProgram
      this.formInsModel.IdModalidad = datFind.IdModality
      this.formInsModel.IdJornada = datFind.IdWorkday
      this.formInsModel.IdConvoca = datFind.IdPeriod
      this.formInsModel.IdHomolo = datFind.ReqHomologation
      this.formInsModel.IdNivelEstu = datFind.IdHomLevelStudy
      this.formInsModel.IdInstiEdu = datFind.HomEducationInstitution
      this.formInsModel.IdTitulo = datFind.HomObtainedTitle
      this.formInsModel.IdYearTitu = datFind.HomGraduationYear
      if (this.formInsModel.IdHomolo === true && this.formInsModel.IdLevelForm <= 2) {
        document.getElementById("div_IdHomoloText").classList.remove('noShow');
        document.getElementById("div_IdNivelEstu").classList.remove('noShow');
        document.getElementById("div_IdInstiEdu").classList.remove('noShow');
        document.getElementById("div_IdTitulo").classList.remove('noShow');
        document.getElementById("div_IdYearTitu").classList.remove('noShow');
      } else {
        this.formInsModel.IdHomolo = false
      }
      var vDateEndSchool = datFind.DateEndSchool;
      var dateResEndSchool = vDateEndSchool.replace('T00:00:00', '')
      var trueResEndSchool = dateResEndSchool.split("/");
      if (trueResEndSchool.length === 3)
      {
        var vDayExpEndSchool = trueResEndSchool[0];
        var vMonthExpEndSchool = trueResEndSchool[1];
        var vYearExpEndSchool = trueResEndSchool[2];
        this.formInsModel.IdDaySelectCol = vDayExpEndSchool;
        this.formInsModel.IdMonthSelectCol = vMonthExpEndSchool;
        this.formInsModel.IdYearSelectCol = vYearExpEndSchool;
      }

      return true
    },
    dataformat: function(InfDaT){
      return IberoHelpers.dataObjDate(InfDaT);
    },
    dataObjFindJs: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjFind(infoDaT,FinDaT);
    },
    dataObjAllFind: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
    },    
    executeProcess: function (event) {  
      
      switch (event.target.id) {
        case "IdDocType":
          this.formInsModel.IdDocument = '';
        break;              
        case "IdDocument":          
            if(event.type === 'blur' && this.formInsModel.IdDocType !== '' && this.formInsModel.IdDocument !== '')
            {              
              var exPerson = IberoHelpers.findUserInscription(this.$store,this.formInsModel);  
              exPerson.then(Response => {  
                if (Response.data) {                                    
                  // Cargar datos
                  //this.loadFindData(Response.data[0])
                  //validar si existe en Zoho               
                  var exContactByZoho = IberoHelpers.findContactByZoho(this.$store,this.formInsModel,'identificationNumber');
                  //document.getElementById("div_IdDeepening").hidden = true;
                }else{
                  //validar si existe en Zoho               
                  var exContactByZoho = IberoHelpers.findContactByZoho(this.$store,this.formInsModel,'identificationNumber');
                }
              })
              
            }
            
        break;
        case "IdCelPhone":          
            if(event.type === 'blur' && this.formInsModel.IdCelPhone !== '')
            {              
              //validar si existe en Zoho               
              var exContactByZoho = IberoHelpers.findContactByZoho(this.$store,this.formInsModel,'mobile');
            }            
        break;        
        case "IdMail":          
            if(event.type === 'blur' && this.formInsModel.IdMail !== '')
            {              
              //validar si existe en Zoho               
              var exContactByZoho = IberoHelpers.findContactByZoho(this.$store,this.formInsModel,'email');
            }            
        break;
        case "IdAddress":
          this.$root.$emit('bv::show::modal', 'bv-modal-address', '#btnShow')          
        break;
        case "IdInteProgram":

          this.$store.state.PeriodoList.length = 0;  
          this.formInscription.fields3[4].values = ''; 

          this.formInsModel.IdModalidad = '';
          this.formInsModel.IdJornada = '';        
          this.formInsModel.IdConvoca = '';            
          this.$store.state.PeriodoList.length = 0;
          this.$store.state.WorkdayList.length = 0;    
          this.$store.state.ModalityList.length = 0;      
          if(event.target.value === ''){            
            this.formInscription.fields3[1].values = '';
            this.formInscription.fields3[2].values = '';
            this.formInscription.fields3[3].values = '';            
          }else{
            IberoHelpers.getModalityListByProgram(this.$store.state.ApiIbero.WSParametric,this.$store.state.ModalityList,event.target.value,this.formInsModel.IdOperator);
            this.formInscription.fields3[2].values = this.$store.state.ModalityList;
          }
          for (var i=0; i < this.$store.state.ProgramList.length; i++) {
                  if(this.$store.state.ProgramList[i].id == this.formInsModel.IdInteProgram)
                  {
                    if(this.$store.state.ProgramList[i].requirePayment  != '' && this.$store.state.ProgramList[i].requirePayment != null) 
                    {
                      this.alertnofileSend = false
                      let message = {
                              title: 'Información Importante!',
                              body: 'Señor usuario, ' + this.$store.state.ProgramList[i].requirePayment,
                          }
                          let options = {
                              okText: 'Aceptar',                
                          }                    
                          this.$dialog.alert(message, options)
                        return;
                    }
                  }
                }
          var programSelected = IberoHelpers.dataObjFind(this.$store.state.ProgramList, this.formInsModel.IdInteProgram);
          switch(programSelected){
            case "MAESTRIA EN EDUCACION VIR":
              document.getElementById("div_IdDeepening").hidden = false;
              this.formInscription.fields3[6].validate.required = true;
            break;
            default:
              document.getElementById("div_IdDeepening").hidden = true;
              this.formInscription.fields3[6].validate.required = false;
            break;
          }
        break;
        case "IdTypeIncome":
          this.$store.state.PeriodoList.length = 0;  
          this.formInscription.fields3[4].values = '';  


          if(event.target.value === ''){            
            this.formInscription.fields3[1].values = '';
          }
          else{
            if(event.target.value === 'N'){
              IberoHelpers.getProgramsListByOperator(this.$store.state.ApiIbero.WSParametric,this.$store.state.ProgramList,this.formInsModel.IdOperator,this.formInsModel.IdLevelForm);
              this.formInscription.fields3[1].values = this.$store.state.ProgramList;

              document.getElementById("cbox_IdHomolo").checked = false;
              document.getElementById("cbox_IdHomolo").disabled = true;
              document.getElementById("div_IdHomolo").classList.add('noShow');
              
              this.formInsModel.IdNivelEstu = 1;
              this.formInsModel.IdInstiEdu = 'N/A';
              this.formInsModel.IdTitulo = 'N/A';
              this.formInsModel.IdYearTitu = (new Date).getFullYear();
              document.getElementById("div_IdHomoloText").classList.add('noShow');
              document.getElementById("div_IdNivelEstu").classList.add('noShow');
              document.getElementById("div_IdInstiEdu").classList.add('noShow');
              document.getElementById("div_IdTitulo").classList.add('noShow');
              document.getElementById("div_IdYearTitu").classList.add('noShow');    
            }else{
              if(event.target.value === 'X'){
                IberoHelpers.getProgramsListByOperator(this.$store.state.ApiIbero.WSParametric,this.$store.state.ProgramList,this.formInsModel.IdOperator,this.formInsModel.IdLevelForm);
                this.formInscription.fields3[1].values = this.$store.state.ProgramList;
                document.getElementById("cbox_IdHomolo").checked = true;
                document.getElementById("cbox_IdHomolo").disabled = true;
                document.getElementById("div_IdHomolo").classList.remove('noShow');
                this.formInsModel.IdHomolo = true;
                this.formInsModel.IdNivelEstu = '';
                this.formInsModel.IdInstiEdu = '';
                this.formInsModel.IdTitulo = '';
                this.formInsModel.IdYearTitu = '';  
                document.getElementById("div_IdHomoloText").classList.remove('noShow');
                document.getElementById("div_IdNivelEstu").classList.remove('noShow');
                document.getElementById("div_IdInstiEdu").classList.remove('noShow');
                document.getElementById("div_IdTitulo").classList.remove('noShow');
                document.getElementById("div_IdYearTitu").classList.remove('noShow');

                this.formInscription.fields3[8].validate.required = true;
                this.formInscription.fields3[9].validate.required = true;
                this.formInscription.fields3[10].validate.required = true;
                this.formInscription.fields3[11].validate.required = true;
              }
              else{
                IberoHelpers.getProgramsListByOperator(this.$store.state.ApiIbero.WSParametric,this.$store.state.ProgramList,this.formInsModel.IdOperator,this.formInsModel.IdLevelForm);
                this.formInscription.fields3[1].values = this.$store.state.ProgramList;
                document.getElementById("cbox_IdHomolo").checked = true;
                document.getElementById("cbox_IdHomolo").disabled = true;
                document.getElementById("div_IdHomolo").classList.remove('noShow');
                this.formInsModel.IdHomolo = true;
                this.formInsModel.IdNivelEstu = 1;
                this.formInsModel.IdInstiEdu = '';
                this.formInsModel.IdTitulo = '';
                this.formInsModel.IdYearTitu = '';            
                document.getElementById("div_IdHomoloText").classList.remove('noShow');
                document.getElementById("div_IdNivelEstu").classList.remove('noShow');
                document.getElementById("div_IdInstiEdu").classList.remove('noShow');
                document.getElementById("div_IdTitulo").classList.remove('noShow');
                document.getElementById("div_IdYearTitu").classList.remove('noShow');

                this.formInscription.fields3[8].validate.required = false;
                this.formInscription.fields3[9].validate.required = false;
                this.formInscription.fields3[10].validate.required = false;
                this.formInscription.fields3[11].validate.required = false;
              }
            }
          }
          break;
        case "IdModalidad":
          this.$store.state.PeriodoList.length = 0;  
          this.formInscription.fields3[4].values = this.$store.state.PeriodoList;  
          this.formInsModel.IdJornada = '';          
          this.formInsModel.IdConvoca = '';
          this.$store.state.PeriodoList.length = 0;
          this.$store.state.WorkdayList.length = 0;
          if(event.target.value === ''){            
            this.formInscription.fields3[2].values = '';
            this.formInscription.fields3[3].values = '';
          }else{
            IberoHelpers.getWorkdayListByModality(this.$store.state.ApiIbero.WSParametric,this.$store.state.WorkdayList,event.target.value,this.formInsModel.IdInteProgram,this.formInsModel.IdOperator);
            this.formInscription.fields3[3].values = this.$store.state.WorkdayList;
          }
        break;  
        case "IdJornada":
          this.formInsModel.IdConvoca = '';
          this.$store.state.PeriodoList.length = 0;       
          if(event.target.value === ''){            
            this.formInscription.fields3[4].values = '';
          }else{
            var listPeriod = IberoHelpers.getPeriodListByWorkDay(this.$store.state.ApiIbero.WSParametric,event.target.value,this.formInsModel.IdModalidad,this.formInsModel.IdInteProgram,this.formInsModel.IdTypeIncome);  
            
            listPeriod.then(
              Response => { 
                this.$store.state.PeriodoList.length = 0;
                for (var i=0; i < Response.data.length; i++) {
                  this.$store.state.PeriodoList.push(
                    {id:Response.data[i].idPeriod,value:Response.data[i].desPeriod + ' : ' + IberoHelpers.dataObjDate(Response.data[i].datStartDate) + ' - ' + IberoHelpers.dataObjDate(Response.data[i].datEndDate) }
                  )           
                }    
                this.formInscription.fields3[4].values = this.$store.state.PeriodoList;
                this.formInsModel.IdConvoca = Response.data[0].idPeriod;
              }
            )
            var listPlan = IberoHelpers.getPlanListByWorkDay(this.$store.state.ApiIbero.WSParametric,event.target.value,this.formInsModel.IdModalidad,this.formInsModel.IdInteProgram,this.formInsModel.IdTypeIncome);

            listPlan.then(
              Response2 => {
                this.$store.state.PlanList.length = 0;
                for (var i=0; i < Response2.data.length; i++) {                  
                  this.$store.state.PlanList.push(
                    {id:Response2.data[i].idPlan,value:Response2.data[i].desPlan }
                  )       
                }    
                this.formInscription.fields3[5].values =  this.$store.state.PlanList;
                this.formInsModel.IdPlan = Response2.data[0].idPlan;
              }
            )

          } 
        break;                     
        case "IdState":
          this.formInsModel.IdCity = '';
          if(event.target.value === ''){            
            this.formInscription.fields1[8].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,event.target.value);
            this.formInscription.fields1[8].values = this.$store.state.CityList;
          }
        break;
        case "IdEtnia":
          if(event.target.value === ''){            
            this.formInscription.fields2[15].values = '';
          }else{
            IberoHelpers.GetEthnicityReference(this.$store.state.ApiIbero.WSParametric,this.$store.state.EtniaList,event.target.value);
            this.formInscription.fields2[15].values = this.$store.state.EtniaList;
                      

          }
        break;
        case "IdStateRes":
          this.formInsModel.IdCityRes = '';
          if(event.target.value === ''){            
            this.formInscription.fields2[3].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListRes,event.target.value);
            this.formInscription.fields2[3].values = this.$store.state.CityListRes;
          }
        break;
        case "IdStateBirth":
          this.formInsModel.IdCityBirth = '';
          if(event.target.value === ''){            
            this.formInscription.fields2[6].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListBirth,event.target.value);
            this.formInscription.fields2[6].values = this.$store.state.CityListBirth;
          }
        break; 
        case "IdStateCol":
          this.formInsModel.IdCityCol = '';
          if(event.target.value === ''){            
            this.formInscription.fields4[4].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListCol,event.target.value);
            this.formInscription.fields4[4].values = this.$store.state.CityListCol;
          }
        break;
        case "cbox_IdTermiCondi":                   
          event.target.disabled = true;   
        break;
        case "cbox_IdComproMatricula":                   
          event.target.disabled = true;   
        break;
        case "cbox_IdHomolo":
          if(this.formInsModel.IdHomolo === true){
            this.formInsModel.IdNivelEstu = '';
            this.formInsModel.IdInstiEdu = '';
            this.formInsModel.IdTitulo = '';
            this.formInsModel.IdYearTitu = '';            
            document.getElementById("div_IdHomoloText").classList.remove('noShow');
            document.getElementById("div_IdNivelEstu").classList.remove('noShow');
            document.getElementById("div_IdInstiEdu").classList.remove('noShow');
            document.getElementById("div_IdTitulo").classList.remove('noShow');
            document.getElementById("div_IdYearTitu").classList.remove('noShow');
          }else{
            this.formInsModel.IdNivelEstu = 1;
            this.formInsModel.IdInstiEdu = 'N/A';
            this.formInsModel.IdTitulo = 'N/A';
            this.formInsModel.IdYearTitu = (new Date).getFullYear();
            document.getElementById("div_IdHomoloText").classList.add('noShow');
            document.getElementById("div_IdNivelEstu").classList.add('noShow');
            document.getElementById("div_IdInstiEdu").classList.add('noShow');
            document.getElementById("div_IdTitulo").classList.add('noShow');
            document.getElementById("div_IdYearTitu").classList.add('noShow');            
          }
        break;
        case "IdLevelForm":                       
          var codDegree = this.dataObjAllFind(this.$store.state.DegreeList,event.target.value)
          document.getElementById("div_IdJornadaEsc").classList.add('noShow');
          if(codDegree.codVal === 'POS') {
              this.formInscription.fields4[0].validate.required = true;
              this.formInscription.fields4[1].name = 'Nombre de la Universidad';
              this.formInscription.fields4[1].placeholder = 'Nombre de la Universidad';
              this.formInscription.fields4[1].validate.required = true;              
              this.formInscription.fields4[2].validate.required = true;  
              this.formInscription.fields4[3].validate.required = true;
              this.formInscription.fields4[4].validate.required = true;
              // poner campo Titulo Obtenido visiable 
              document.getElementById("div_TituloPregrado").classList.remove('noShow');

              // quita el requerico a los campos de icfes
                            
              this.formInscription.fields4[11].validate.required = false;
              this.formInscription.fields4[12].validate.required = false;
              this.formInscription.fields4[13].validate.required = false;
              this.formInscription.fields4[14].validate.required = false;
              
              document.getElementById("div_IdHomolo").classList.remove('noShow');
              if(this.formInsModel.IdHomolo === true){
                this.formInsModel.IdNivelEstu = '';
                this.formInsModel.IdInstiEdu = '';
                this.formInsModel.IdTitulo = '';
                this.formInsModel.IdYearTitu = '';            
                document.getElementById("div_IdHomoloText").classList.remove('noShow');
                document.getElementById("div_IdNivelEstu").classList.remove('noShow');
                document.getElementById("div_IdInstiEdu").classList.remove('noShow');
                document.getElementById("div_IdTitulo").classList.remove('noShow');
                document.getElementById("div_IdYearTitu").classList.remove('noShow');
              }else{
                this.formInsModel.IdNivelEstu = 1;
                this.formInsModel.IdInstiEdu = 'N/A';
                this.formInsModel.IdTitulo = 'N/A';
                this.formInsModel.IdYearTitu = (new Date).getFullYear();
                document.getElementById("div_IdHomoloText").classList.add('noShow');
                document.getElementById("div_IdNivelEstu").classList.add('noShow');
                document.getElementById("div_IdInstiEdu").classList.add('noShow');
                document.getElementById("div_IdTitulo").classList.add('noShow');
                document.getElementById("div_IdYearTitu").classList.add('noShow');            
              }     
              document.getElementById("div_IdTypeColegio").classList.remove('noShow');
              document.getElementById("div_IdColegio").classList.remove('noShow');
              document.getElementById("div_IdCityCol").classList.remove('noShow');
              document.getElementById("div_IdStateCol").classList.remove('noShow');
              //document.getElementById("div_IdJornadaEsc").classList.remove('noShow'); 
              document.getElementById("div_IdICFESText").classList.add('noShow');        
              document.getElementById("div_IdNumRegICFES").classList.add('noShow');        
              document.getElementById("div_IdNumRegYearICFES").classList.add('noShow');
              document.getElementById("div_IdDocTypeICFES").classList.add('noShow');
              document.getElementById("div_IdNumICFES").classList.add('noShow');     
          } else if(codDegree.codVal === 'CON' || codDegree.codVal === 'OPG') {            
              this.formInscription.fields4[0].validate.required = false;
              this.formInscription.fields4[1].name = 'Colegio';
              this.formInscription.fields4[1].placeholder = 'Colegio';
              this.formInscription.fields4[1].validate.required = false;  
              this.formInscription.fields4[2].validate.required = false;  
              this.formInscription.fields4[3].validate.required = false;
              this.formInscription.fields4[4].validate.required = false;

              document.getElementById("div_TituloPregrado").classList.add('noShow');
              this.formInscription.fields4[5].validate.required = false;              
              this.formInscription.fields4[6].validate.required = false;  
              this.formInscription.fields4[7].validate.required = false;  
              this.formInscription.fields4[8].validate.required = false;
              document.getElementById("IdTypeIncome").disabled = true;
              this.formInsModel.IdTypeIncome = "N";

              IberoHelpers.getProgramsListByOperator(this.$store.state.ApiIbero.WSParametric,this.$store.state.ProgramList,this.formInsModel.IdOperator,this.formInsModel.IdLevelForm);
              this.formInscription.fields3[1].values = this.$store.state.ProgramList;

              document.getElementById("cbox_IdHomolo").checked = false;
              document.getElementById("cbox_IdHomolo").disabled = true;
              document.getElementById("div_IdHomolo").classList.add('noShow');
              
              this.formInsModel.IdNivelEstu = 1;
              this.formInsModel.IdInstiEdu = 'N/A';
              this.formInsModel.IdTitulo = 'N/A';
              this.formInsModel.IdYearTitu = (new Date).getFullYear();
              document.getElementById("div_IdHomoloText").classList.add('noShow');
              document.getElementById("div_IdNivelEstu").classList.add('noShow');
              document.getElementById("div_IdInstiEdu").classList.add('noShow');
              document.getElementById("div_IdTitulo").classList.add('noShow');
              document.getElementById("div_IdYearTitu").classList.add('noShow');
              
               // quita el requerico a los campos de icfes
                            
              this.formInscription.fields4[11].validate.required = false;
              this.formInscription.fields4[12].validate.required = false;
              this.formInscription.fields4[13].validate.required = false;
              this.formInscription.fields4[14].validate.required = false;

              document.getElementById("div_IdHomolo").classList.add('noShow');
              this.formInsModel.IdNivelEstu = 1;
              this.formInsModel.IdInstiEdu = 'N/A';
              this.formInsModel.IdTitulo = 'N/A';
              this.formInsModel.IdYearTitu = (new Date).getFullYear();
              document.getElementById("div_IdHomoloText").classList.add('noShow');
              document.getElementById("div_IdNivelEstu").classList.add('noShow');
              document.getElementById("div_IdInstiEdu").classList.add('noShow');
              document.getElementById("div_IdTitulo").classList.add('noShow');
              document.getElementById("div_IdYearTitu").classList.add('noShow');      
                          
              document.getElementById("div_IdTypeColegio").classList.add('noShow');
              document.getElementById("div_IdColegio").classList.add('noShow');
              document.getElementById("div_IdCityCol").classList.add('noShow');
              document.getElementById("div_IdStateCol").classList.add('noShow');
              document.getElementById("div_IdJornadaEsc").classList.add('noShow'); 
              document.getElementById("div_IdDaySelectCol").classList.add('noShow'); 
              document.getElementById("div_IdMonthSelectCol").classList.add('noShow'); 
              document.getElementById("div_IdYearSelectCol").classList.add('noShow'); 
              document.getElementById("div_IdICFESText").classList.add('noShow');                      
              document.getElementById("div_IdNumRegICFES").classList.add('noShow');        
              document.getElementById("div_IdNumRegYearICFES").classList.add('noShow');
              document.getElementById("div_IdDocTypeICFES").classList.add('noShow');
              document.getElementById("div_IdNumICFES").classList.add('noShow');
          } else {
              this.formInscription.fields4[0].validate.required = true;
              this.formInscription.fields4[1].name = 'Colegio';
              this.formInscription.fields4[1].placeholder = 'Colegio';
              this.formInscription.fields4[1].validate.required = true;              
              this.formInscription.fields4[2].validate.required = false;  
              this.formInscription.fields4[3].validate.required = true;
              this.formInscription.fields4[4].validate.required = true;

              document.getElementById("div_TituloPregrado").classList.add('noShow');                           

               // quita el requerico a los campos de icfes            

              document.getElementById("div_IdHomolo").classList.remove('noShow');
              if(this.formInsModel.IdHomolo === true){
                this.formInsModel.IdNivelEstu = '';
                this.formInsModel.IdInstiEdu = '';
                this.formInsModel.IdTitulo = '';
                this.formInsModel.IdYearTitu = '';            
                document.getElementById("div_IdHomoloText").classList.remove('noShow');
                document.getElementById("div_IdNivelEstu").classList.remove('noShow');
                document.getElementById("div_IdInstiEdu").classList.remove('noShow');
                document.getElementById("div_IdTitulo").classList.remove('noShow');
                document.getElementById("div_IdYearTitu").classList.remove('noShow');
              }else{
                this.formInsModel.IdNivelEstu = 1;
                this.formInsModel.IdInstiEdu = 'N/A';
                this.formInsModel.IdTitulo = 'N/A';
                this.formInsModel.IdYearTitu = (new Date).getFullYear();
                document.getElementById("div_IdHomoloText").classList.add('noShow');
                document.getElementById("div_IdNivelEstu").classList.add('noShow');
                document.getElementById("div_IdInstiEdu").classList.add('noShow');
                document.getElementById("div_IdTitulo").classList.add('noShow');
                document.getElementById("div_IdYearTitu").classList.add('noShow');            
              }    

              document.getElementById("div_IdTypeColegio").classList.remove('noShow');
              document.getElementById("div_IdColegio").classList.remove('noShow');
              document.getElementById("div_IdCityCol").classList.remove('noShow');
              document.getElementById("div_IdStateCol").classList.remove('noShow');
              //document.getElementById("div_IdJornadaEsc").classList.remove('noShow'); 
              document.getElementById("div_IdICFESText").classList.remove('noShow');        
              document.getElementById("div_IdNumRegICFES").classList.remove('noShow');        
              document.getElementById("div_IdNumRegYearICFES").classList.remove('noShow');
              document.getElementById("div_IdDocTypeICFES").classList.remove('noShow');
              document.getElementById("div_IdNumICFES").classList.remove('noShow');            
          }
        break;           
        case "IdNacionality":
          if (event.target.value != 169) {
            document.getElementById("div_IdStateBirth").classList.add('noShow');
            document.getElementById("div_IdCityBirth").classList.add('noShow');
            this.formInsModel.IdStateBirth = '11'
            this.formInsModel.IdCityBirth = '11001'
          } else {
            document.getElementById("div_IdStateBirth").classList.remove('noShow');
            document.getElementById("div_IdCityBirth").classList.remove('noShow');
            this.formInsModel.IdStateBirth = ''
            this.formInsModel.IdCityBirth = ''            
          }
        break;  
        return true;
      }        
    },    
    onComplete: function() {
      this.alertdanger = false;
      this.alertdangerOrden = false;
      return new Promise((resolve, reject) => {
          this.$refs.obsFields4.validate().then(results => {    
            if (!results) {
              IberoHelpers.scrollToTop(0,300);
              resolve(false)
            } else {
              let loader = this.$loading.show();
              var totalinf = IberoHelpers.sendFormInscription(this.$store,this.formInsModel, this.formAddModel);  
              totalinf.then(
                Response => { 
                  IberoHelpers.scrollToTop(0,320);
                  if(Response === false || Response.data.status != 200 ){                    
                    this.alertdanger = true;
                    resolve(false);
                  }else{
                    try
                    {
                      this.sumaryData = JSON.parse(Response.data.message)[0]
                      if(this.sumaryData['REGISTRO EN LÍNEA'][0].Referencia) {
                        if(Response.data.message.length > 0){
                          var res = IberoHelpers.postPayOrderInscripcionOMA(this.$store,this.formInsModel, this.formAddModel);
                          var dataLink = this.$store.state.ApiIbero.WSIceBerg;
                          res.then(Response => {
                                if(Response.data.message === "Success" || Response.data.status === 200 )
                                {
                                  if (Response.data.title != 0) 
                                  {
                                      if (this.formInsModel.IdInteProgram != '2')
                                      {
                                        this.alertdangerOrden = false;
                                      }
                                      else
                                      {
                                        this.alertdangerOrden = false;
                                      }
                                  }
                                  else this.alertdangerOrden = false;
                                }
                            else this.alertdangerOrden = false;
                          })
                          this.FormInscripcion = false;
                          resolve(true)
                        } else {
                          this.alertdanger = true;
                          resolve(false);  
                        }
                      }else{
                        this.FormInscripcion = false;
                          resolve(true)
                      }  

                    }catch(error) {
                      this.alertdanger = true;
                      resolve(false);
                    };           
                  }
                  loader.hide();
                }
              )            
            }            
          });
      });
    },
    beforeTabSwitch1: function() {
      if(this.validationAlfanumeric(this.formInsModel.IdDocument))
      {    
        return new Promise((resolve, reject) => {
            this.$refs.obsFields1.validate().then(results => {         
              if (!results) {
                IberoHelpers.scrollToTop(0,500);
                resolve(false)
              } else {
                this.formInsModel.IdInteProgram = '';
                this.formInsModel.IdModalidad = '';
                this.formInsModel.IdJornada = '';        
                this.formInsModel.IdConvoca = '';
                IberoHelpers.sendFormInscriptionTemp(this.$store,this.formInsModel);
                resolve(true)
              }
            });
        });
    }
    },
    beforeTabSwitch2: function() {
      if((this.formInsModel.IdDaySelectBirth == this.formInsModel.IdDaySelectReq) && 
      (this.formInsModel.IdMonthSelectBirth == this.formInsModel.IdMonthSelectReq) && 
      (this.formInsModel.IdYearSelectBirth == this.formInsModel.IdYearSelectReq)){
        this.alertBirth = false;
        return new Promise((resolve, reject) => {
          this.$refs.obsFields2.validate().then(results => {                
            if (!results) {
              IberoHelpers.scrollToTop(0,500);
              resolve(false)
            }else{
              resolve(true)
            }
          });
        });
      }
      else{
        this.alertBirth = true;
        IberoHelpers.scrollToTop(0,150);
      }
    },
    beforeTabSwitch3: function() {   
      return new Promise((resolve, reject) => {
          this.$refs.obsFields3.validate().then(results => {                
            if (!results) {
              IberoHelpers.scrollToTop(0,500);
              resolve(false)
            }else{
              resolve(true)
            }
          });
      });
    }   
  },
  created () {
    if(this.$route.params.operador !== undefined){
      var resultOpera = IberoHelpers.getOperatorByName(this.$store, this.$route.params.operador)
      resultOpera.then(Response => {
        this.formInsModel.IdOperator = Response.data[0].idOperator        
        this.formInscription.fields1[0].hidden = false
      })      
    } else {
      this.formInscription.fields1[0].hidden = false
    }
  },
  data() {
    return {
      FormInscripcion: true,
      alertdanger: false,
      alertdangerOrden: false,
      infoValidacion : true,
      alertBirth: false,
      sumaryData: [],
      labelFields:{
        fields1:'Identificacion del Usuario',
        fields2:'Datos Personales',
        fields3:'Informacion Institucional',
        fields4:'Escolaridad',
      },
      formAddModel: {
        IdAddressList: '',
        IdAddressStreet: '',
        IdAddressNumTxt: '',
        IdAddressNum: '',
        IdAddressRefTxt: '',
        IdAddressRef: '',
        IdAddressExtra: '',
      },
      formInsModel: {
        Campaign: this.$route.params.referencia,
        IdOperator: 1,
        IdLevelForm: '',
        IdDocType: '',
        IdDocument: '',
        IdDateExpDoc: '',
        IdDaySelect: '',
        IdMonthSelect: '',
        IdYearSelect: '',
        IdState: '',
        IdCity: '',
        IdNombreP: '', 
        IdNombreS: '', 
        IdApellidosP: '', 
        IdApellidosS: '', 
        IdCelPhone: '', 
        IdHomePhone: '', 
        IdMail: '',
        IdTermiCondi: '',
        IdAddress: '',
        IdNeighbor: '',
        IdStateRes: '',
        IdCityRes: '',
        IdNacionality: '169',
        IdStateBirth: '',
        IdCityBirth: '',
        IdDateBirth: '',
        IdDaySelectBirth: '',
        IdMonthSelectBirth: '',
        IdYearSelectBirth: '',
        IdDaySelectReq: '',
        IdMonthSelectReq: '',
        IdYearSelectReq: '',
        IdGender: '',
        IdEtnia: '',
        IdLeyVete: '',
        IdDiscapa: '',
        IdCivilState: '',
        IdEPS: '',
        IdEPSQA: '',    
        IdEstrato: '',    
        IdContactName: '',
        IdContactPhone: '',
        IdContactCity: '',
        IdContactAdres: '',
        IdWork: '',
        IdPersons: '',
        IdMaterial: '',
        IdTypeIncome: '',
        IdModalidad: '',
        IdInteProgram: '',
        IdJornada: '',
        IdConvoca: '',
        IdConvoca: '',
        IdDeepening: '',
        IdHomolo: false,
        IdHomoloText: '',
        IdICFESText: '',
        IdNivelEstu: 1,
        IdInstiEdu: 'N/A',
        IdTitulo: 'N/A',
        IdYearTitu:  (new Date).getFullYear(),
        IdTypeColegio: '',
        IdColegio: '',
        IdStateCol: '',
        IdCityCol: '',
        IdJornadaEsc: '',
        IdDaySelectCol: '',
        IdMonthSelectCol: '',
        IdYearSelectCol: '',
        IdNumRegICFES: '',
        IdNumRegYearICFES: '',
        IdDocTypeICFES: '',
        IdNumICFES: '',        
        IdComproMatricula: '',
      }, 
      formAddress:[
        {
            id: 'IdAddressList',
            model: 'IdAddressList',
            type: 'Select2',  
            values: this.$store.state.listAddress,
            placeholder: 'Dirección',
            validate: {              
              required: true              
            },
            class: 'col-md-3'               
        },
        {
            id: 'IdAddressStreet',
            model: 'IdAddressStreet',
            type: 'input',           
            values: this.$store.state.listAddress,
            placeholder: 'Dirección',
            validate: {              
              required: true, 
              alpha_num: true,
              max: 4,                            
            },
            class: 'col-md-2'               
        },
        {            
            id: 'IdAddressNumTxt',
            model: 'IdAddressNumTxt',
            type: 'html',  
            values: '#',                     
            class: 'col-md-1'                
          },      
        {
            id: 'IdAddressNum',
            model: 'IdAddressNum',
            type: 'input',  
            values: '',
            placeholder: '#', 
            validate: {              
              required: true, 
              alpha_num: true,
              max: 4,               
            },
            class: 'col-md-2'              
        },
        {            
            id: 'IdAddressRefTxt',
            model: 'IdAddressRefTxt',
            type: 'html',  
            values: '-',                     
            class: 'col-md-1'                
          },   
        {
            id: 'IdAddressRef',
            model: 'IdAddressRef',
            type: 'input',  
            placeholder: '#',
            values: '',
            validate: {              
              required: true, 
              alpha_num: true,
              max: 4,                
            },
            class: 'col-md-2'               
        },        
        {
            id: 'IdAddressExtra',
            model: 'IdAddressExtra',
            type: 'input',  
            placeholder: 'Informacion adicional',
            values: '',
            validate: {              
              max: 35,                
            },
            class: 'col-md-11'               
        },                       
      ],
      formInscription:{       
        fields1:[
          {
            id: 'IdOperator',
            model: 'IdOperator',
            name: 'Operador',
            type: 'Select',  
            placeholder: "Operador",
            values: this.$store.state.OperatorList,
            validate: {              
              required: true              
            },
            class: 'col-md-12',
            hidden: true,
          },
          {            
            id: 'IdLevelForm',
            model: 'IdLevelForm',
            name: 'Nivel de Formación',
            type: 'Select',  
            placeholder: "Nivel de Formación",
            values: this.$store.state.DegreeList,
            validate: {              
              required: true              
            },
            class: 'col-md-12',
          },          
          {            
            id: 'IdDocType',
            model: 'IdDocType',
            name: 'Tipo de Documento',
            type: 'Select',  
            placeholder: "Tipo de Documento",
            values: this.$store.state.DocTypesList,
            validate: {              
              required: true              
            },
            class: 'col-md-12',
          },
          {            
            id: 'IdDocument',
            model: 'IdDocument',
            name: 'Documento de Identidad',
            type: 'input',  
            placeholder: 'Documento de Identidad',
            values: '',
            validate: {              
              required: true, 
              min: 6,              
              max: 15            
            },
            class: 'col-md-12'               
          },
          {            
            id: 'IdDaySelect',
            model: 'IdDaySelect',
            name: 'Fecha de Expedición de Documento',
            type: 'Select',  
            placeholder: "Día",
            validate: {              
              required: true              
            },
            class: 'col-md-4',
            values: [
                { id: "01", value: "1" },
                { id: "02", value: "2" },
                { id: "03", value: "3" },
                { id: "04", value: "4" },
                { id: "05", value: "5" },
                { id: "06", value: "6" },
                { id: "07", value: "7" },
                { id: "08", value: "8" },
                { id: "09", value: "9" },
                { id: "10", value: "10" },
                { id: "11", value: "11" },
                { id: "12", value: "12" },
                { id: "13", value: "13" },
                { id: "14", value: "14" },
                { id: "15", value: "15" },
                { id: "16", value: "16" },
                { id: "17", value: "17" },
                { id: "18", value: "18" },
                { id: "19", value: "19" },
                { id: "20", value: "20" },
                { id: "21", value: "21" },
                { id: "22", value: "22" },
                { id: "23", value: "23" },
                { id: "24", value: "24" },
                { id: "25", value: "25" },
                { id: "26", value: "26" },
                { id: "27", value: "27" },
                { id: "28", value: "28" },
                { id: "29", value: "29" },
                { id: "30", value: "30" },
                { id: "31", value: "31" }
            ]
          },
          {
            id: 'IdMonthSelect',
            model: 'IdMonthSelect',
            name: '',
            type: 'Select',  
            placeholder: 'Mes',
            validate: {              
              required: true              
            },
            class: 'col-md-4',            
            values: [
                { id: "01", value: "Enero" },
                { id: "02", value: "Febrero" },
                { id: "03", value: "Marzo" },
                { id: "04", value: "Abril" },
                { id: "05", value: "Mayo" },
                { id: "06", value: "Junio" },
                { id: "07", value: "Julio" },
                { id: "08", value: "Agosto" },
                { id: "09", value: "Septiembre" },
                { id: "10", value: "Octubre" },
                { id: "11", value: "Noviembre" },
                { id: "12", value: "Diciembre" }
            ]
          },
          {
            id: 'IdYearSelect',
            model: 'IdYearSelect',
            name: '',
            type: 'Select',  
            placeholder: 'Año',
            validate: {              
              required: true              
            },
            class: 'col-md-4',            
            values:[
                { id: "2026", value: "2026" },
                { id: "2025", value: "2025" },
                { id: "2024", value: "2024" },
                { id: "2023", value: "2023" },
                { id: "2022", value: "2022" },
                { id: "2021", value: "2021" },
                { id: "2020", value: "2020" },
                { id: "2019", value: "2019" },
                { id: "2018", value: "2018" },
                { id: "2017", value: "2017" },
                { id: "2016", value: "2016" },
                { id: "2015", value: "2015" },
                { id: "2014", value: "2014" },
                { id: "2013", value: "2013" },
                { id: "2012", value: "2012" },
                { id: "2011", value: "2011" },
                { id: "2010", value: "2010" },
                { id: "2009", value: "2009" },
                { id: "2008", value: "2008" },
                { id: "2007", value: "2007" },
                { id: "2006", value: "2006" },
                { id: "2005", value: "2005" },
                { id: "2004", value: "2004" },
                { id: "2003", value: "2003" },
                { id: "2002", value: "2002" },
                { id: "2001", value: "2001" },
                { id: "2000", value: "2000" },
                { id: "1999", value: "1999" },
                { id: "1998", value: "1998" },
                { id: "1997", value: "1997" },
                { id: "1996", value: "1996" },
                { id: "1995", value: "1995" },
                { id: "1994", value: "1994" },
                { id: "1993", value: "1993" },
                { id: "1992", value: "1992" },
                { id: "1991", value: "1991" },
                { id: "1990", value: "1990" },
                { id: "1989", value: "1989" },
                { id: "1988", value: "1988" },
                { id: "1987", value: "1987" },
                { id: "1986", value: "1986" },
                { id: "1985", value: "1985" },
                { id: "1984", value: "1984" },
                { id: "1983", value: "1983" },
                { id: "1982", value: "1982" },
                { id: "1981", value: "1981" },
                { id: "1980", value: "1980" },
                { id: "1979", value: "1979" },
                { id: "1978", value: "1978" },
                { id: "1977", value: "1977" },
                { id: "1976", value: "1976" },
                { id: "1975", value: "1975" },
                { id: "1974", value: "1974" },
                { id: "1973", value: "1973" },
                { id: "1972", value: "1972" },
                { id: "1971", value: "1971" },
                { id: "1970", value: "1970" },
                { id: "1969", value: "1969" },
                { id: "1968", value: "1968" },
                { id: "1967", value: "1967" },
                { id: "1966", value: "1966" },
                { id: "1965", value: "1965" },
                { id: "1964", value: "1964" },
                { id: "1963", value: "1963" },
                { id: "1962", value: "1962" },
                { id: "1961", value: "1961" },
                { id: "1960", value: "1960" },
                { id: "1959", value: "1959" },
                { id: "1958", value: "1958" },
                { id: "1957", value: "1957" },
                { id: "1956", value: "1956" },
                { id: "1955", value: "1955" },
                { id: "1954", value: "1954" },
                { id: "1953", value: "1953" },
                { id: "1952", value: "1952" },
                { id: "1951", value: "1951" },
                { id: "1950", value: "1950" },
                { id: "1949", value: "1949" },
                { id: "1948", value: "1948" },
                { id: "1947", value: "1947" },
                { id: "1946", value: "1946" },
                { id: "1945", value: "1945" },
                { id: "1944", value: "1944" },
                { id: "1943", value: "1943" },
                { id: "1942", value: "1942" },
                { id: "1941", value: "1941" },
                { id: "1940", value: "1940" },
            ],
          },
          {
            id: 'IdState',
            model: 'IdState',
            name: 'Departamento de Expedición Documento',
            type: 'Select',  
            placeholder: 'Departamento de Expedición Documento',
            class: 'col-md-12',            
            values: this.$store.state.StateList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdCity',
            model: 'IdCity',
            name: 'Ciudad de Expedición Documento',
            type: 'Select',  
            placeholder: 'Ciudad de Expedición Documento',
            validate: {              
              required: true              
            },
            class: 'col-md-12',            
            values: '',
          },
          {            
            id: 'IdNombreP',
            model: 'IdNombreP',
            name: 'Primer Nombre',
            type: 'input',  
            placeholder: 'Primer Nombre',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },
          {            
            id: 'IdNombreS',
            model: 'IdNombreS',
            name: 'Segundo Nombre',
            type: 'input',  
            placeholder: 'Segundo Nombre',
            values: '',
            validate: {              
              required: false              
            },
            class: 'col-md-6'               
          },            
          {            
            id: 'IdApellidosP',
            model: 'IdApellidosP',
            name: 'Primer Apellido',
            type: 'input',  
            placeholder: 'Primer Apellido',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },
          {            
            id: 'IdApellidosS',
            model: 'IdApellidosS',
            name: 'Segun Apellido',
            type: 'input',  
            placeholder: 'Segundo Apellido',
            values: '',
            validate: {              
              required: false              
            },
            class: 'col-md-6'               
          },           
          {            
            id: 'IdCelPhone',
            model: 'IdCelPhone',
            name: 'Teléfono Celular',
            type: 'input',  
            placeholder: 'Teléfono Celular',
            values: '',
            validate: {
              required: true, 
              numeric: true,
              max: 10,
              min: 10 
            },  
            class: 'col-md-12'               
          },      
          {            
            id: 'IdHomePhone',
            model: 'IdHomePhone',
            name: 'Teléfono Fijo',
            type: 'input',  
            placeholder: 'Teléfono Fijo',
            values: '',
            validate: {
              required: false, 
              numeric: true,
              max: 7,
              min: 6 
            },         
            class: 'col-md-12'               
          },  
          {            
            id: 'IdMail',
            model: 'IdMail',
            name: 'Correo Electrónico',
            type: 'input',  
            placeholder: 'Correo Electrónico',
            values: '',
            validate: {
              required: true, 
              email: true 
            },
            class: 'col-md-12'               
          },
          {            
            id: 'IdTermiCondi',
            name: 'Términos y Condiciones',
            model: 'IdTermiCondi',
            type: 'accepted',  
            disabled: false,
            placeholder: 'Acepto los <a class="linkTerm" href="' + this.$store.state.linkTermiCondi + '" target="_blank">Términos y Condiciones</a> de uso.',
            values: '',
            validate: {              
              required: true,
            },
            class: 'col-md-12 linkref'                
          },          
        ],
        fields2:[
          {
            id: 'IdAddress',
            model: 'IdAddress',
            name: 'Dirección',
            type: 'inputkey',  
            placeholder: 'Dirección',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },
          {
            id: 'IdNeighbor',
            model: 'IdNeighbor',
            name: 'Barrio',
            type: 'input',
            placeholder: 'BRR',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-4'               
          }, 
          {
            id: 'IdStateRes',
            model: 'IdStateRes',
            name: 'Departamento de Residencia',
            type: 'Select',  
            placeholder: 'Departamento de Residencia',
            class: 'col-md-6',            
            values: this.$store.state.StateList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdCityRes',
            model: 'IdCityRes',
            name: 'Ciudad de Residencia',
            type: 'Select',  
            placeholder: 'Ciudad de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: '',
          },   
          {
            id: 'IdNacionality',
            model: 'IdNacionality',
            name: 'Nacionalidad',
            type: 'Select',  
            placeholder: 'Nacionalidad',
            class: 'col-md-6',            
            values: this.$store.state.CountriesList,
            validate: {              
              required: true              
            },
          },           
          {
            id: 'IdStateBirth',
            model: 'IdStateBirth',
            name: 'Departamento de Nacimiento',
            type: 'Select',  
            placeholder: 'Departamento de Nacimiento',
            class: 'col-md-6',            
            values: this.$store.state.StateList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdCityBirth',
            model: 'IdCityBirth',
            name: 'Ciudad de Nacimiento',
            type: 'Select',  
            placeholder: 'Ciudad de Nacimiento',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: '',
          },    
          {
            id: 'IdGender',
            model: 'IdGender',
            name: 'Genero',
            type: 'Select',  
            placeholder: 'Genero',
            class: 'col-md-6',            
            values: this.$store.state.GenderList,
            validate: {              
              required: true              
            },
          },
          {            
            id: 'IdDaySelectBirth',
            model: 'IdDaySelectBirth',
            name: 'Fecha de Nacimiento',
            type: 'Select',  
            placeholder: "Día",
            values: [
                { id: "1", value: "1" },
                { id: "2", value: "2" },
                { id: "3", value: "3" },
                { id: "4", value: "4" },
                { id: "5", value: "5" },
                { id: "6", value: "6" },
                { id: "7", value: "7" },
                { id: "8", value: "8" },
                { id: "9", value: "9" },
                { id: "10", value: "10" },
                { id: "11", value: "11" },
                { id: "12", value: "12" },
                { id: "13", value: "13" },
                { id: "14", value: "14" },
                { id: "15", value: "15" },
                { id: "16", value: "16" },
                { id: "17", value: "17" },
                { id: "18", value: "18" },
                { id: "19", value: "19" },
                { id: "20", value: "20" },
                { id: "21", value: "21" },
                { id: "22", value: "22" },
                { id: "23", value: "23" },
                { id: "24", value: "24" },
                { id: "25", value: "25" },
                { id: "26", value: "26" },
                { id: "27", value: "27" },
                { id: "28", value: "28" },
                { id: "29", value: "29" },
                { id: "30", value: "30" },
                { id: "31", value: "31" }
            ],
            validate: {              
              required: true              
            },
            class: 'col-md-2',
          },
          {
            id: 'IdMonthSelectBirth',
            model: 'IdMonthSelectBirth',
            name: '',
            type: 'Select',  
            placeholder: 'Mes',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values: [
                { id: "1", value: "Enero" },
                { id: "2", value: "Febrero" },
                { id: "3", value: "Marzo" },
                { id: "4", value: "Abril" },
                { id: "5", value: "Mayo" },
                { id: "6", value: "Junio" },
                { id: "7", value: "Julio" },
                { id: "8", value: "Agosto" },
                { id: "9", value: "Septiembre" },
                { id: "10", value: "Octubre" },
                { id: "11", value: "Noviembre" },
                { id: "12", value: "Diciembre" }
            ]
          },
          {
            id: 'IdYearSelectBirth',
            model: 'IdYearSelectBirth',
            name: '',
            type: 'Select',  
            placeholder: 'Año',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values:[
                { id: "2012", value: "2012" },
                { id: "2011", value: "2011" },
                { id: "2010", value: "2010" },
                { id: "2009", value: "2009" },
                { id: "2008", value: "2008" },
                { id: "2007", value: "2007" },
                { id: "2006", value: "2006" },
                { id: "2005", value: "2005" },
                { id: "2004", value: "2004" },
                { id: "2003", value: "2003" },
                { id: "2002", value: "2002" },
                { id: "2001", value: "2001" },
                { id: "2000", value: "2000" },
                { id: "1999", value: "1999" },
                { id: "1998", value: "1998" },
                { id: "1997", value: "1997" },
                { id: "1996", value: "1996" },
                { id: "1995", value: "1995" },
                { id: "1994", value: "1994" },
                { id: "1993", value: "1993" },
                { id: "1992", value: "1992" },
                { id: "1991", value: "1991" },
                { id: "1990", value: "1990" },
                { id: "1989", value: "1989" },
                { id: "1988", value: "1988" },
                { id: "1987", value: "1987" },
                { id: "1986", value: "1986" },
                { id: "1985", value: "1985" },
                { id: "1984", value: "1984" },
                { id: "1983", value: "1983" },
                { id: "1982", value: "1982" },
                { id: "1981", value: "1981" },
                { id: "1980", value: "1980" },
                { id: "1979", value: "1979" },
                { id: "1978", value: "1978" },
                { id: "1977", value: "1977" },
                { id: "1976", value: "1976" },
                { id: "1975", value: "1975" },
                { id: "1974", value: "1974" },
                { id: "1973", value: "1973" },
                { id: "1972", value: "1972" },
                { id: "1971", value: "1971" },
                { id: "1970", value: "1970" },
                { id: "1969", value: "1969" },
                { id: "1968", value: "1968" },
                { id: "1967", value: "1967" },
                { id: "1966", value: "1966" },
                { id: "1965", value: "1965" },
                { id: "1964", value: "1964" },
                { id: "1963", value: "1963" },
                { id: "1962", value: "1962" },
                { id: "1961", value: "1961" },
                { id: "1960", value: "1960" },
                { id: "1959", value: "1959" },
                { id: "1958", value: "1958" },
                { id: "1957", value: "1957" },
                { id: "1956", value: "1956" },
                { id: "1955", value: "1955" },
                { id: "1954", value: "1954" },
                { id: "1953", value: "1953" },
                { id: "1952", value: "1952" },
                { id: "1951", value: "1951" },
                { id: "1950", value: "1950" },
                { id: "1949", value: "1949" },
                { id: "1948", value: "1948" },
                { id: "1947", value: "1947" },
                { id: "1946", value: "1946" },
                { id: "1945", value: "1945" },
                { id: "1944", value: "1944" },
                { id: "1943", value: "1943" },
                { id: "1942", value: "1942" },
                { id: "1941", value: "1941" },
                { id: "1940", value: "1940" },
            ],
          },
          
          {            
            id: 'IdDaySelectReq',
            model: 'IdDaySelectReq',
            name: 'Confirmación Fecha de Nacimiento',
            type: 'Select',  
            placeholder: "Día",
            values: [
                { id: "1", value: "1" },
                { id: "2", value: "2" },
                { id: "3", value: "3" },
                { id: "4", value: "4" },
                { id: "5", value: "5" },
                { id: "6", value: "6" },
                { id: "7", value: "7" },
                { id: "8", value: "8" },
                { id: "9", value: "9" },
                { id: "10", value: "10" },
                { id: "11", value: "11" },
                { id: "12", value: "12" },
                { id: "13", value: "13" },
                { id: "14", value: "14" },
                { id: "15", value: "15" },
                { id: "16", value: "16" },
                { id: "17", value: "17" },
                { id: "18", value: "18" },
                { id: "19", value: "19" },
                { id: "20", value: "20" },
                { id: "21", value: "21" },
                { id: "22", value: "22" },
                { id: "23", value: "23" },
                { id: "24", value: "24" },
                { id: "25", value: "25" },
                { id: "26", value: "26" },
                { id: "27", value: "27" },
                { id: "28", value: "28" },
                { id: "29", value: "29" },
                { id: "30", value: "30" },
                { id: "31", value: "31" }
            ],
            validate: {              
              required: true              
            },
            class: 'col-md-2',
          },
          {
            id: 'IdMonthSelectReq',
            model: 'IdMonthSelectReq',
            name: '',
            type: 'Select',  
            placeholder: 'Mes',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values: [
                { id: "1", value: "Enero" },
                { id: "2", value: "Febrero" },
                { id: "3", value: "Marzo" },
                { id: "4", value: "Abril" },
                { id: "5", value: "Mayo" },
                { id: "6", value: "Junio" },
                { id: "7", value: "Julio" },
                { id: "8", value: "Agosto" },
                { id: "9", value: "Septiembre" },
                { id: "10", value: "Octubre" },
                { id: "11", value: "Noviembre" },
                { id: "12", value: "Diciembre" }
            ]
          },
          {
            id: 'IdYearSelectReq',
            model: 'IdYearSelectReq',
            name: '',
            type: 'Select',  
            placeholder: 'Año',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values:[
                { id: "2012", value: "2012" },
                { id: "2011", value: "2011" },
                { id: "2010", value: "2010" },
                { id: "2009", value: "2009" },
                { id: "2008", value: "2008" },
                { id: "2007", value: "2007" },
                { id: "2006", value: "2006" },
                { id: "2005", value: "2005" },
                { id: "2004", value: "2004" },
                { id: "2003", value: "2003" },
                { id: "2002", value: "2002" },
                { id: "2001", value: "2001" },
                { id: "2000", value: "2000" },
                { id: "1999", value: "1999" },
                { id: "1998", value: "1998" },
                { id: "1997", value: "1997" },
                { id: "1996", value: "1996" },
                { id: "1995", value: "1995" },
                { id: "1994", value: "1994" },
                { id: "1993", value: "1993" },
                { id: "1992", value: "1992" },
                { id: "1991", value: "1991" },
                { id: "1990", value: "1990" },
                { id: "1989", value: "1989" },
                { id: "1988", value: "1988" },
                { id: "1987", value: "1987" },
                { id: "1986", value: "1986" },
                { id: "1985", value: "1985" },
                { id: "1984", value: "1984" },
                { id: "1983", value: "1983" },
                { id: "1982", value: "1982" },
                { id: "1981", value: "1981" },
                { id: "1980", value: "1980" },
                { id: "1979", value: "1979" },
                { id: "1978", value: "1978" },
                { id: "1977", value: "1977" },
                { id: "1976", value: "1976" },
                { id: "1975", value: "1975" },
                { id: "1974", value: "1974" },
                { id: "1973", value: "1973" },
                { id: "1972", value: "1972" },
                { id: "1971", value: "1971" },
                { id: "1970", value: "1970" },
                { id: "1969", value: "1969" },
                { id: "1968", value: "1968" },
                { id: "1967", value: "1967" },
                { id: "1966", value: "1966" },
                { id: "1965", value: "1965" },
                { id: "1964", value: "1964" },
                { id: "1963", value: "1963" },
                { id: "1962", value: "1962" },
                { id: "1961", value: "1961" },
                { id: "1960", value: "1960" },
                { id: "1959", value: "1959" },
                { id: "1958", value: "1958" },
                { id: "1957", value: "1957" },
                { id: "1956", value: "1956" },
                { id: "1955", value: "1955" },
                { id: "1954", value: "1954" },
                { id: "1953", value: "1953" },
                { id: "1952", value: "1952" },
                { id: "1951", value: "1951" },
                { id: "1950", value: "1950" },
                { id: "1949", value: "1949" },
                { id: "1948", value: "1948" },
                { id: "1947", value: "1947" },
                { id: "1946", value: "1946" },
                { id: "1945", value: "1945" },
                { id: "1944", value: "1944" },
                { id: "1943", value: "1943" },
                { id: "1942", value: "1942" },
                { id: "1941", value: "1941" },
                { id: "1940", value: "1940" },
            ],
          },              
          {
            id: 'IdEtnia',
            model: 'IdEtnia',
            name: 'Grupo Étnico',
            type: 'Select',  
            placeholder: 'Grupo Étnico',
            class: 'col-md-6',            
            values: this.$store.state.EthnicityList,
            validate: {              
              required: true              
            },
          }, 
          {
            id: 'IdEtniaRef',
            model: 'IdEtniaRef',
            name: 'Sub Grupo Étnico',
            type: 'Select',  
            placeholder: 'Sub Grupo Étnico',
            class: 'col-md-6',            
            values: '',
            validate: {              
              required: false              
            },
          },
          {
            id: 'IdLeyVete',
            model: 'IdLeyVete',
            name: 'Eres beneficiario de la ley de Veteranos de acuerdo a la Ley 1979 del 2019',
            type: 'Select',  
            placeholder: 'Eres beneficiario de la ley de Veteranos',
            class: 'col-md-6',            
            values: [
              { id: '1', value: 'Veterano' },
              { id: '2', value: 'Cónyuge o compañero (a) permanente del veterano' },
              { id: '3', value: 'Hijo de veterano hasta los veinticinco (25) años de edad' },
              { id: '4', value: 'Padre / madre del veterano' },
              { id: '5', value: 'No aplica' },
            ],
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdDiscapa',
            model: 'IdDiscapa',
            name: 'Discapacidad',
            type: 'Select',  
            placeholder: 'Discapacidad',
            class: 'col-md-6',            
            values: this.$store.state.DesabilityList,
            validate: {              
              required: true              
            },
          }, 
          {
            id: 'IdCivilState',
            model: 'IdCivilState',
            name: 'Estado Civil',
            type: 'Select',  
            placeholder: 'Estado Civil',
            class: 'col-md-6',            
            values: this.$store.state.MaritalStatusList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdEPS',
            model: 'IdEPS',
            name: 'EPS',
            type: 'Select',  
            placeholder: 'EPS',
            class: 'col-md-6',            
            values: this.$store.state.EPSList,
            validate: {              
              required: true              
            },
          },    
          {
            id: 'IdEPSQA',
            model: 'IdEPSQA',
            name: 'Calidad EPS',
            type: 'Select',  
            placeholder: 'Calidad EPS',
            class: 'col-md-6',            
            values: this.$store.state.EPSQAList,
            validate: {              
              required: true              
            },
          },    
          {
            id: 'IdEstrato',
            model: 'IdEstrato',
            name: 'Estrato Socioeconómico',
            type: 'Select',  
            placeholder: 'Estrato Socioeconómico',
            values: this.$store.state.listEstrato,                        
            validate: {              
              required: false              
            },
            class: 'col-md-6'                      
          },   
          {       
            id: 'IdContactName',
            model: 'IdContactName',
            name: 'Nombre del Acudiente',
            type: 'input',  
            placeholder: 'Nombre del Acudiente',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },           
          {            
            id: 'IdContactPhone',
            model: 'IdContactPhone',
            name: 'Teléfono del Acudiente',
            type: 'input',  
            placeholder: 'Teléfono del Acudiente',
            values: '',
            validate: {
              required: true, 
              numeric: true,
              max: 10,
              min: 6
            },  
            class: 'col-md-6'               
          },
          {            
            id: 'IdContactCity',
            model: 'IdContactCity',
            name: 'Ciudad del Acudiente',
            type: 'input',  
            placeholder: 'Ciudad del Acudiente',
            values: '',
            validate: {
              required: false
            },  
            class: 'col-md-6'               
          },
          {            
            id: 'IdContactAdres',
            model: 'IdContactAdres',
            name: 'Dirección del Acudiente',
            type: 'input',  
            placeholder: 'Dirección del Acudiente',
            values: '',
            validate: {
              required: false
            },  
            class: 'col-md-6'               
          },             
          {
            id: 'IdWork',
            model: 'IdWork',
            name: 'Se encuentra laborando actualmente',
            type: 'Select',  
            placeholder: 'Se encuentra laborando actualmente',
            values: this.$store.state.listWork,                        
            validate: {              
              required: true              
            },
            class: 'col-md-6'                      
          },             
          {
            id: 'IdPersons',
            model: 'IdPersons',
            name: 'Cuantas personas dependen económicamente de usted',
            type: 'Select',  
            placeholder: 'Cuantas personas dependen económicamente de usted',
            values: this.$store.state.listPersons,                        
            validate: {              
              required: true              
            },
            class: 'col-md-6'                      
          },             
          {
            id: 'IdMaterial',
            model: 'IdMaterial',
            name: 'Cuentas con material (ordenador, audífonos...)',
            type: 'Select',  
            placeholder: 'Cuentas con material',
            values: this.$store.state.listMAterial,                        
            validate: {              
              required: true              
            },
            class: 'col-md-6'                      
          } 
        ],
        fields3:[
          {
            id: 'IdTypeIncome',
            model: 'IdTypeIncome',
            name: 'Tipo de Ingreso',
            type: 'Select',
            placeholder: 'Tipo de Ingreso',
            class: 'col-md-6',
            values: [
              { id: "N", value: "Primer Ingreso" },
              { id: "X", value: "Transferente Externo" },
              { id: "T", value: "Transferente Interno" }
            ],
            validate: {
              required: true
            }
          },
          {
            id: 'IdInteProgram',
            model: 'IdInteProgram',
            name: 'Programa de Interés',
            type: 'Select',  
            placeholder: 'Programa de Interés',
            class: 'col-md-6',            
            values: this.$store.state.ProgramList,
            validate: {              
              required: true              
            },
          },           
          {
            id: 'IdModalidad',
            model: 'IdModalidad',
            name: 'Modalidad',
            type: 'Select',  
            placeholder: 'Modalidad',
            class: 'col-md-6',            
            values: this.$store.state.ModalityList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdJornada',
            model: 'IdJornada',
            name: 'Jornada',
            type: 'Select',  
            placeholder: 'Jornada',
            class: 'col-md-6',            
            values: this.$store.state.WorkdayList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdConvoca',
            model: 'IdConvoca',
            name: 'Período',
            type: 'Select',  
            placeholder: 'Período',
            class: 'col-md-6',            
            values: this.$store.state.PeriodoList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdPlan',
            model: 'IdPlan',
            name: 'Plan',
            type: 'Select',  
            placeholder: 'Plan',
            class: 'col-md-6',   
            disabled: true,         
            values: this.$store.state.PlanList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdDeepening',
            model: 'IdDeepening',
            name: 'Línea de Profundización',
            type: 'Select',  
            placeholder: 'Línea de Profundización',
            class: 'col-md-6',            
            values: [
              { id: "Línea de profundización Interculturalidad", value: "Línea de profundización Interculturalidad" },
              { id: "Línea de profundización Inclusión", value: "Línea de profundización Inclusión" },
            ],
            validate: {              
              required: false              
            },
          },
          {            
            id: 'IdHomolo',
            model: 'IdHomolo',
            name: 'Solicita Homologación',            
            type: 'accepted',  
            placeholder: 'Solicita Homologación',
            values: '',                     
            class: 'col-md-12 linkref'                
          }, 
          {            
            id: 'IdHomoloText',
            model: 'IdHomoloText',
            type: 'html',  
            values: '<div  class="alert alert-info" role="alert"><div>Recuerde que los documentos requeridos (excepto para los Transferentes Interno) para realizar una homologación son:</div><br><div><ul><li>Diploma o acta del programa a homologar</li><li>Certificado de notas</li><li>Contenidos programáticos</li></ul></div></div>',                     
            class: 'col-md-12 noShow'                
          },             
          {
            id: 'IdNivelEstu',
            model: 'IdNivelEstu',
            name: 'Nivel de Estudio Alcanzado',
            type: 'Select',  
            placeholder: 'Nivel de Estudio Alcanzado',
            class: 'col-md-6 noShow',            
            values: this.$store.state.HomDegreeList,
            validate: {              
              required: true              
            },
          },  
          {            
            id: 'IdInstiEdu',
            model: 'IdInstiEdu',
            name: 'Institución de Educación',
            type: 'input',  
            placeholder: 'Institución de Educación',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6 noShow'               
          },  
          {            
            id: 'IdTitulo',
            model: 'IdTitulo',
            name: 'Título Obtenido',
            type: 'input',  
            placeholder: 'Título Obtenido',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6 noShow'               
          },  
          {            
            id: 'IdYearTitu',
            model: 'IdYearTitu',
            name: 'Año de Graduación',
            type: 'input',  
            placeholder: 'Año de Graduación',
            values: '',
            validate: {              
              required: true,
              length: 4,
              numeric: true,
              between: ['1900',(new Date).getFullYear()]             
            },
            class: 'col-md-6 noShow'               
          }                                                            
        ],
        fields4:[
          {
            id: 'IdTypeColegio',
            model: 'IdTypeColegio',
            name: 'Tipo de Institución',
            type: 'Select',  
            placeholder: "Tipo de Institución",   
            values: this.$store.state.TipocColegioList,                        
            validate: {              
              required: true              
            },
            class: 'col-md-6'                      
          },
          {            
            id: 'IdColegio',
            model: 'IdColegio',
            name: 'Institución',
            type: 'input',  
            placeholder: 'Colegio',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          }, 
          {            
            id: 'TituloPregrado',
            model: 'TituloPregrado',
            name: 'Indique El Titulo Obtenido En Su Pregrado.',
            type: 'input',  
            placeholder: 'Titulo Obtenido En Su Pregrado',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6 noShow'               
          },  
          {
            id: 'IdStateCol',
            model: 'IdStateCol',
            name: 'Departamento',
            type: 'Select',  
            placeholder: 'Departamento',
            class: 'col-md-6',            
            values: this.$store.state.StateList,
            validate: {              
              required: true              
            },
          },
          {
            id: 'IdCityCol',
            model: 'IdCityCol',
            name: 'Ciudad',
            type: 'Select',  
            placeholder: 'Ciudad',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: '',
          },    
          {
            id: 'IdJornadaEsc',
            model: 'IdJornadaEsc',
            name: 'Jornada',
            type: 'Select',  
            placeholder: "Jornada",
            values: this.$store.state.JornadaList,                        
            validate: {              
              required: false              
            },
            class: 'col-md-6'                      
          },           
          {            
            id: 'IdDaySelectCol',
            model: 'IdDaySelectCol',
            name: 'Fecha culminación',
            type: 'Select',  
            placeholder: "Día",
            values: [
                { id: "1", value: "1" },
                { id: "2", value: "2" },
                { id: "3", value: "3" },
                { id: "4", value: "4" },
                { id: "5", value: "5" },
                { id: "6", value: "6" },
                { id: "7", value: "7" },
                { id: "8", value: "8" },
                { id: "9", value: "9" },
                { id: "10", value: "10" },
                { id: "11", value: "11" },
                { id: "12", value: "12" },
                { id: "13", value: "13" },
                { id: "14", value: "14" },
                { id: "15", value: "15" },
                { id: "16", value: "16" },
                { id: "17", value: "17" },
                { id: "18", value: "18" },
                { id: "19", value: "19" },
                { id: "20", value: "20" },
                { id: "21", value: "21" },
                { id: "22", value: "22" },
                { id: "23", value: "23" },
                { id: "24", value: "24" },
                { id: "25", value: "25" },
                { id: "26", value: "26" },
                { id: "27", value: "27" },
                { id: "28", value: "28" },
                { id: "29", value: "29" },
                { id: "30", value: "30" },
                { id: "31", value: "31" }
            ],
            validate: {              
              required: true              
            },
            class: 'col-md-2',
          },
          {
            id: 'IdMonthSelectCol',
            model: 'IdMonthSelectCol',
            name: '',
            type: 'Select',  
            placeholder: 'Mes',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values: [
                { id: "1", value: "Enero" },
                { id: "2", value: "Febrero" },
                { id: "3", value: "Marzo" },
                { id: "4", value: "Abril" },
                { id: "5", value: "Mayo" },
                { id: "6", value: "Junio" },
                { id: "7", value: "Julio" },
                { id: "8", value: "Agosto" },
                { id: "9", value: "Septiembre" },
                { id: "10", value: "Octubre" },
                { id: "11", value: "Noviembre" },
                { id: "12", value: "Diciembre" }
            ]
          },
          {
            id: 'IdYearSelectCol',
            model: 'IdYearSelectCol',
            name: '',
            type: 'Select',  
            placeholder: 'Año',
            validate: {              
              required: true              
            },
            class: 'col-md-2',            
            values:[
                { id: "2026", value: "2026" },
                { id: "2025", value: "2025" },
                { id: "2024", value: "2024" },
                { id: "2023", value: "2023" },
                { id: "2022", value: "2022" },
                { id: "2021", value: "2021" },
                { id: "2020", value: "2020" },
                { id: "2019", value: "2019" },
                { id: "2018", value: "2018" },
                { id: "2017", value: "2017" },
                { id: "2016", value: "2016" },
                { id: "2015", value: "2015" },
                { id: "2014", value: "2014" },
                { id: "2013", value: "2013" },
                { id: "2012", value: "2012" },
                { id: "2011", value: "2011" },
                { id: "2010", value: "2010" },
                { id: "2009", value: "2009" },
                { id: "2008", value: "2008" },
                { id: "2007", value: "2007" },
                { id: "2006", value: "2006" },
                { id: "2005", value: "2005" },
                { id: "2004", value: "2004" },
                { id: "2003", value: "2003" },
                { id: "2002", value: "2002" },
                { id: "2001", value: "2001" },
                { id: "2000", value: "2000" },
                { id: "1999", value: "1999" },
                { id: "1998", value: "1998" },
                { id: "1997", value: "1997" },
                { id: "1996", value: "1996" },
                { id: "1995", value: "1995" },
                { id: "1994", value: "1994" },
                { id: "1993", value: "1993" },
                { id: "1992", value: "1992" },
                { id: "1991", value: "1991" },
                { id: "1990", value: "1990" },
                { id: "1989", value: "1989" },
                { id: "1988", value: "1988" },
                { id: "1987", value: "1987" },
                { id: "1986", value: "1986" },
                { id: "1985", value: "1985" },
                { id: "1984", value: "1984" },
                { id: "1983", value: "1983" },
                { id: "1982", value: "1982" },
                { id: "1981", value: "1981" },
                { id: "1980", value: "1980" },
                { id: "1979", value: "1979" },
                { id: "1978", value: "1978" },
                { id: "1977", value: "1977" },
                { id: "1976", value: "1976" },
                { id: "1975", value: "1975" },
                { id: "1974", value: "1974" },
                { id: "1973", value: "1973" },
                { id: "1972", value: "1972" },
                { id: "1971", value: "1971" },
                { id: "1970", value: "1970" },
                { id: "1969", value: "1969" },
                { id: "1968", value: "1968" },
                { id: "1967", value: "1967" },
                { id: "1966", value: "1966" },
                { id: "1965", value: "1965" },
                { id: "1964", value: "1964" },
                { id: "1963", value: "1963" },
                { id: "1962", value: "1962" },
                { id: "1961", value: "1961" },
                { id: "1960", value: "1960" },
                { id: "1959", value: "1959" },
                { id: "1958", value: "1958" },
                { id: "1957", value: "1957" },
                { id: "1956", value: "1956" },
                { id: "1955", value: "1955" },
                { id: "1954", value: "1954" },
                { id: "1953", value: "1953" },
                { id: "1952", value: "1952" },
                { id: "1951", value: "1951" },
                { id: "1950", value: "1950" },
                { id: "1949", value: "1949" },
                { id: "1948", value: "1948" },
                { id: "1947", value: "1947" },
                { id: "1946", value: "1946" },
                { id: "1945", value: "1945" },
                { id: "1944", value: "1944" },
                { id: "1943", value: "1943" },
                { id: "1942", value: "1942" },
                { id: "1941", value: "1941" },
                { id: "1940", value: "1940" },
            ],
          }, 
          {
            id: 'ClearZone',              
            type: 'ClearZone',              
            class: 'col-md-6'                      
          },   
          {            
            id: 'IdICFESText',
            model: 'IdICFESText',
            type: 'html',  
            values: '<div class="">ICFES</div>',                     
            class: 'col-md-12'                
          },                     
          {            
            id: 'IdNumRegICFES',
            model: 'IdNumRegICFES',
            name: 'Número de Registro',
            type: 'input',  
            placeholder: 'Número de Registro',
            values: '',
            validate: {
              required: true, 
              max: 14,
              min: 5 
            },
            class: 'col-md-6'               
          },  
          {            
            id: 'IdNumRegYearICFES',
            model: 'IdNumRegYearICFES',
            name: 'Año',
            type: 'input',  
            placeholder: 'Año',
            values: '',
            validate: {              
              required: true,
              length: 4,
              numeric: true,
              between: ['1900',(new Date).getFullYear()]                   
            },
            class: 'col-md-6'               
          },                      
          {            
            id: 'IdDocTypeICFES',
            model: 'IdDocTypeICFES',
            name: 'Tipo de Identificación',
            type: 'Select',  
            placeholder: "Tipo de Identificación",
            values: this.$store.state.DocTypesListICFES,
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },                                 
          {            
            id: 'IdNumICFES',
            model: 'IdNumICFES',
            name: 'Número de Identificación',
            type: 'input',  
            placeholder: 'Número de Identificación',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-6'               
          },
          {            
            id: 'IdComproMatricula',
            name: 'Compromiso de matrícula',
            model: 'IdComproMatricula',
            type: 'accepted',  
            disabled: false,
            placeholder: 'Acepto que he leído y aprobado el <a class="linkTerm" href="' + this.$store.state.linkComproMatricula + '" target="_blank">compromiso de matrícula</a> de la Corporación Universitaria Iberoamericana.',
            values: '',
            validate: {              
              required: true,
            },
            class: 'col-md-12 linkref'                
          },                       
        ]
      },
    }
  }
}
</script>

<style scope>
.FormInscripcion {
  background-color: #fff;
}

.FormInscripcionOK .wizard-card-footer{
  display: none;
}

.row
{
  display: flex;
  flex-wrap: wrap;
}

.totalform {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #fff;
}

.wizard-progress-with-circle {
  display: none !important;
}

.wizard-nav-pills, .wizard-card-footer{
  margin-left: 10% !important;   
  margin-right: 10% !important;
} 

.vue-form-generator, fieldset{
  display: contents;
}

.linkref{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}

#div_IdICFESText{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -20px;
}

#div_IdAddressNumTxt, #div_IdAddressRefTxt{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}


.linkref a{
  color: #222 !important;
}

.active
{
  color: #222;
}

.noShow{
  display: none;
}

#div_IdTermiCondi .titleRef, #div_IdHomolo .titleRef, #div_IdComproMatricula .titleRef{
  color: #ffffff;
  margin-top: 10px;
  font-size: 20px;
}

.infoForm .colRefForm div
{
  color: #000;
}

.titleRefSumary{
  font-weight: bold;
  text-transform: uppercase;
  text-decoration-line: underline;
  margin-top: 20px;
  margin-bottom: 20px;
}

.titleSumary{
    font-weight: bold;
}

.listSumary{
  font-size: 13px;
}
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.botonPay {
  margin-top: 5px;
  max-width: 250px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.detalleAddress .is-invalid-form{
  display: none;
}

#sum_IdOperator, #sum_IdICFESText{
  display: none;
}

.botonData{
  margin-right: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}

body {
    background:  #fff;   
}
header {
    background:  #fff;
}

#IdMonthSelect{
  top: 52px;
}

#error_IdMonthSelect{
  margin-top: 55px;
}

#IdYearSelect{
  top: 52px;
}

#IdDaySelectBirth{
  top: 11px;
}

#error_IdYearSelect{
  margin-top: 55px;
}

#IdMonthSelectBirth{
  top: 52px;
}

#error_IdMonthSelectBirth{
  margin-top: 55px;
}

#IdYearSelectBirth{
  top: 52px;
}

#error_IdYearSelectBirth{
  margin-top: 55px;
}
#IdMonthSelectReq{
  top: 52px;
}

#error_IdMonthSelectReq{
  margin-top: 55px;
}

#IdYearSelectReq{
  top: 52px;
}

#error_IdYearSelectReq{
  margin-top: 55px;
}

.col2 {
    flex-basis: none !important;
} 

</style>
